class Tournaments {
    constructor(connectionManager, config) {
        this.connectionManager = connectionManager;
        this.hasHandler = false;
        this.selectionGameId = null;
        this.gameId = null;
        this.currentFee = null;
        this.joinedTournament = null;
        this.active = false;
        this.type = false;
        this.tournamentUsers = [];
        this.countDowns = [];
    }

    init(tournamentId = 0, entryFee = null, type = null, gameId = null) {
        app.events.single(app.events.eventList.page_leave, () => {
            this.active = false;
        });
        this.selectionGameId = gameId;
        this.gameId = gameId;
        app.tournaments.countDowns = [];
        this.active = true;
        this.currentFee = entryFee;
        this.type = type;
        if (!this.hasHandler) {
            this.hasHandler = true;
            this.connectionManager.addHandler(this.terminal.bind(this), "cego:tournaments:msg");
        }
        if (tournamentId) {
            this.globalMode = false;
            this.tournament = $("[data-tournament-id='" + tournamentId + "']");
            if (this.tournament.length) {
                this.participentIcons = $(".tournament-participant-icons");
                this.tournamentState = $(this.tournament[0]).attr("data-state");
                this.participants = $("#participants");
                this.joined = $(".leave").not(".hidden");
                if (this.joined.length) {
                    this.joinedTournament = parseInt(this.joined.attr("data-tournament-id"));
                }
                this.countDown = $(".countdown-container");
                let counter = this.countDown.find("[data-start]");
                if (counter.length && counter.attr("data-start")) {
                    app.tournaments.countDowns["countdown-" + tournamentId] = new Countdown("countdown-" + tournamentId, counter.attr("data-start"), "-");
                }
            } else {
                this.tournament = null;
            }
        } else {
            this.globalMode = true;
            this.updateSelection();
            $(".tournament-mode-selector").on("click", "> a", (el) => {
                if (this.selectionGameId === $(el.currentTarget).attr("data-game_id")) {
                    this.selectionGameId = null;
                } else {
                    this.selectionGameId = $(el.currentTarget).attr("data-game_id");
                }
                this.updateSelection();
            });
            this.joined = $(".user-joined");
            if (this.joined.length) {
                this.joinedTournament = parseInt(this.joined.attr("data-tournament-id"));
            }
            $("[data-start]").each(function () {
                app.tournaments.countDowns[$(this).attr("id")] = new Countdown($(this).attr("id"), $(this).attr("data-start"), "-");
            });
        }
    }

    updateSelection() {
        let tms = $(".tournament-mode-selector > [data-game_id='" + this.selectionGameId + "']");
        if (!tms.hasClass("active")) {
            $(".tournament-mode-selector > a").removeClass("active");
            tms.addClass("active");
        } else {
            $(".tournament-mode-selector > a").removeClass("active");
            $("#tournaments-running .tournament-row").clearQueue().slideDown(200);
            $("#tournaments-planned .tournament-row").clearQueue().slideDown(200);
        }
        this.syncSelection();
    }

    syncSelection() {
        if (this.selectionGameId) {
            $("#tournaments-planned .tournament-row[data-game_id!='" + this.selectionGameId + "']").slideUp(200);
            $("#tournaments-planned .tournament-row[data-game_id='" + this.selectionGameId + "']").slideDown(200);
            $("#tournaments-running .tournament-row[data-game_id!='" + this.selectionGameId + "']").slideUp(200);
            $("#tournaments-running .tournament-row[data-game_id='" + this.selectionGameId + "']").slideDown(200);
        } else {
            $(".tournament-row").slideDown(200);
        }
    }

    jid(tournamentId) {
        if (tournamentId) {
            return 'tournament_' + tournamentId + '@conference.' + app.config.domain + "/" + app.config.user.u;

        } else {
            return 'tournament_0@conference.' + app.config.domain + "/" + app.config.user.u;
        }
    }

    onConnected() {
        return true;
    }

    onDisconnected() {
        return true;
    }

    terminal(message) {
        if (this.active === false) {
            return true;
        }
        const data = app.util.jsonDecode(message.getElementsByTagName("body")[0].innerHTML).data;
        if (data) {
            if (this.globalMode) {
                this.globalView(data);
            } else {
                this.singleView(data);
            }
        }
        return true;
    }

    globalView(data) {
        if (data.id === 0) {
            window.location.reload();
            return true;
        }
        if (this.joinedTournament !== data.id && (this.type === "custom" && (data.t !== "user_fixed_entry_prize" && data.t !== "user_individual_prize")) || (this.type === "standard" && (data.t !== "fixed_entry_prize" && data.t !== "individual_prize"))) {
            return true;
        }
        let tournament = $("[data-tournament-id='" + data.id + "']");
        if (tournament.length) {
            tournament.attr("data-state", data.s);
            this.determineButtons(data);
            switch (data.s) {
                case "planned":
                    if (typeof data.st === "number") {
                        if (typeof app.tournaments.countDowns["countdown-" + data.id] === "undefined" || app.tournaments.countDowns["countdown-" + data.id] === null) {
                            app.tournaments.countDowns["countdown-" + data.id] = new Countdown('countdown-' + data.id, data.st, "-");
                            tournament.find(".countdown-container").slideDown(200);
                            tournament.find(".needed-players").slideUp(200);
                        } else {
                            app.tournaments.countDowns["countdown-" + data.id].set(data.st);
                        }
                    }
                    let fee = tournament.find(".entry-fee");
                    if (data.p !== null && typeof data.p.amount === "number") {
                        app.util.counter("prize-" + data.id, data.p.amount, 2000, false, 0);
                    } else if (fee.length && fee.attr("data-entry-fee")) {
                        tournament.find(".prize-section").slideDown();
                        app.util.counter("prize-" + data.id, fee.attr("data-entry-fee") * data.tu, 2000, false, 0);
                    }
                    if (typeof data.tu === "number") {
                        tournament.find(".users").html(data.tu);
                    }
                    if (typeof data.nu === "number") {
                        tournament.find(".needed").html(data.nu);
                    }
                    break;
                case "pending":
                case "starting":
                    if (typeof app.tournaments.countDowns["countdown-" + data.id] === "object") {
                        app.tournaments.countDowns["countdown-" + data.id].stop();
                    }
                    tournament.find(".countdown-container h3").html(data.stp);
                    $("#tournaments-planned [data-tournament-id='" + data.id + "']").slideUp(200);
                    break;
                case "running":
                    tournament = $("#tournaments-planned [data-tournament-id='" + data.id + "']");
                    if (tournament.length && tournament.attr("data-shown") !== "true") {
                        tournament.attr("data-shown", "true");
                        tournament.slideUp(200, () => {
                            $("#tournaments-running").prepend(tournament);
                            this.syncSelection();
                        });
                    }
                    break;
                case "cancelled":
                case "finishing":
                case "finished":
                case "crashed":
                    tournament.slideUp(200, () => tournament.remove());
                    break;
            }
        } else {
            if (typeof data.g === "undefined" || data.g === this.gameId || this.gameId === null) {
                app.ajax.get("/services/tournaments/row/" + data.id, {}, (tourData) => {
                    tournament = $(tourData.html);
                    tournament.slideUp(0, () => {
                        if (tournament.hasClass("user-joined")) {
                            $("#tournaments-joined").append(tournament);
                        } else if (data.s === "planned" || data.s === "pending" || data.s === "starting") {
                            $("#tournaments-planned").append(tournament);
                        } else if (data.s === "running") {
                            $("#tournaments-running").append(tournament);
                        }
                        if (data.st) {
                            app.tournaments.countDowns["countdown-" + data.id] = new Countdown('countdown-' + data.id, data.st, "-");
                        }
                        this.syncSelection();
                    });
                });
            }
        }
        if (!this.joinedTournament) {
            $(".user-joined").removeClass("user-joined");
        }
    }

    singleView(data) {
        if (this.tournament && parseInt(this.tournament.attr("data-tournament-id")) === data.id) {
            if (data.s !== this.tournamentState) {
                this.tournamentState = data.s;
                switch (data.s) {
                    case "running":
                    case "finished":
                        app.ajax.get("/services/tournaments/state/" + data.id, {}, (data) => {
                            $("#state").html(data.html);
                        });
                        break;
                    case "cancelled":
                    case "crashed":
                        app.ajax.reload("#page");
                        return true;
                }
            }
            switch (data.s) {
                case "planned":
                    if (typeof data.u === "object") {
                        this.populateParticipants(data.u);
                        let foundPlayer = false;
                        for (let u in data.u) {
                            if (parseInt(u) === app.config.user.id) {
                                foundPlayer = true;
                                this.joinedTournament = data.id;
                            }
                        }
                        if (!foundPlayer) {
                            this.revealJoin();
                            this.joinedTournament = null;
                        } else {
                            this.revealLeave();
                        }
                    } else if (typeof data.us === "object") {
                        switch (data.a) {
                            case"ad":
                                this.addParticipant(data.us);
                                break;
                            case "re":
                                this.removeParticipant(data.us);
                                break;
                        }
                        this.determineButtons(data);
                    }
                    if (data.p && typeof data.p.firstPlace === "number") {
                        app.util.counter("prize-pool", data.p.amount, 1500, false, 0);
                        app.util.counter("first-place", data.p.firstPlace, 1500, false, 0);
                        app.util.counter("second-place", data.p.secondPlace, 1000, false, 0);
                        app.util.counter("third-place", data.p.thirdPlace, 500, false, 0);
                    } else if (this.currentFee) {
                        $("#prize-share").slideDown(200);
                        const a = this.currentFee * Math.max(Math.min(data.tu, 30), 3);
                        app.util.counter("prize-pool", a * 0.95, 1500, false, 0);
                        app.util.counter("first-place", a * 0.5, 1500, false, 0);
                        app.util.counter("second-place", a * 0.3, 1000, false, 0);
                        app.util.counter("third-place", a * 0.15, 500, false, 0);
                    } else {
                        $("#prize-share").slideUp(200);
                        app.util.counter("prize-pool", 0, 200, false, 0);
                        app.util.counter("first-place", 0, 200, false, 0);
                        app.util.counter("second-place", 0, 200, false, 0);
                        app.util.counter("third-place", 0, 200, false, 0);
                    }
                    if (data.st) {
                        if (typeof app.tournaments.countDowns["countdown-" + data.id] === "undefined") {
                            this.countDown.slideDown(200);
                            app.tournaments.countDowns["countdown-" + data.id] = new Countdown("countdown-" + data.id, data.st, "-");
                        } else {
                            this.countDown.slideDown(200);
                            app.tournaments.countDowns["countdown-" + data.id].set(data.st);
                        }
                    }
                    if (typeof data.tu === "number") {
                        $("#users-count").html(data.tu);
                    }
                    break;
                case "pending":
                case "starting":
                    this.hideButtons();
                    break;
                case "running":
                case "finished":
                    for (let tableId in data.tau) {
                        let index = 0;
                        const table = $("table[data-id='" + tableId + "']");
                        const rows = table.find("tr");

                        for (let tableUserId in data.tau[tableId]) {
                            const rowElement = $(rows[index]);
                            const userElement = rowElement.find("a");
                            const userTableData = data.tau[tableId][tableUserId];
                            const userData = data.u[userTableData.user_id];
                            userElement.attr("data-gender", userData.k);
                            userElement.attr("data-vip", userData.v ? 1 : 0);
                            userElement.prop("href", "/users/" + userData.u);
                            userElement.text(userData.u);
                            if (userData.u === app.config.user.u) {
                                table.addClass("current-user");
                                userElement.attr("data-current-user", "1");
                            } else {
                                userElement.attr("data-current-user", "0");
                            }
                            if (userTableData.score) {
                                if (data.fti === parseInt(tableId)) {
                                    rowElement.attr("data-state", "final-" + (index + 1));
                                } else {
                                    if (index < data.q) {
                                        rowElement.attr("data-state", "qualified");
                                    } else {
                                        if (userData.u === app.config.user.u) {
                                            $("#open_game").slideUp(200);
                                        }
                                        rowElement.attr("data-state", "unqualified");
                                    }
                                }
                            }
                            index++;
                        }
                    }
                    break;
            }
        }
    }

    determineButtons(data) {
        if (typeof data.us === "object" && data.us.id === app.config.user.id) {
            if (data.a === "ad") {
                this.joinedTournament = data.id;
                let t = $("[data-tournament-id='" + data.id + "']");
                t.addClass("user-joined");
                $("tournaments-joined").append(t);
                this.revealLeave();
                return;
            } else if (data.a === "re") {
                $("[data-tournament-id='" + data.id + "']").removeClass("user-joined");
                this.joinedTournament = null;
                this.revealJoin();
                return;
            }
        }
        let foundPlayer = false;
        if (typeof data.au === "object") {
            for (let i in data.au) {
                if (data.au[i] === app.config.user.id) {
                    foundPlayer = true;
                    if (this.joinedTournament !== data.id) {
                        this.joinedTournament = data.id;
                        $("[data-tournament-id='" + data.id + "']").addClass("user-joined");
                        this.revealLeave();
                    }
                }
            }
            if (!foundPlayer && this.joinedTournament === data.id) {
                this.revealJoin();
                $("[data-tournament-id='" + data.id + "']").removeClass("user-joined");
                this.joinedTournament = null;
            }
        }

        if (data.s !== "planned") {
            this.hideButtons(data.id);
        }
        if (data.s === "finished" && foundPlayer) {
            this.revealJoin();
            this.joinedTournament = null;
        }
    }

    joinTournament(id, entry = null) {
        $(".join").addClass("pulsate-fast");
        this.currentFee = entry;
        if (entry) {
            app.util.counter("current-fee", entry, 1000, false, 0);
        }
        app.ajax.post('/services/tournaments/ajax/join/' + id, {entry: entry}, (data) => {
            $(".join").removeClass("pulsate-fast");
            if (data.status) {
                this.joinedTournament = id;
            }
        }, () => {
            $(".join").removeClass("pulsate-fast");
        });
    }

    leaveTournament(id) {
        $(".leave").addClass("pulsate-fast");
        if (this.currentFee) {
            app.util.counter("current-fee", 0, 200, false, 0);
            this.currentFee = null;
        }
        $("#joined-tournament").slideUp(200);
        app.ajax.delete('/services/tournaments/ajax/leave/' + id, {}, (data) => {
            $(".leave").removeClass("pulsate-fast");
            if (data.status) {
                this.joinedTournament = null;
                this.currentFee = null;
            }
        }, () => {
            $(".leave").removeClass("pulsate-fast");
        });
    }

    revealJoin() {
        if (this.globalMode) {
            $(".leave").slideUp(200);
            this.showJoin();
        } else {
            if (!this.revealed || this.revealed === "leave") {
                this.revealed = "join";
                const leave = $(".leave");
                if (leave.length) {
                    leave.slideUp(200);
                    this.showJoin();
                } else {
                    this.showJoin();
                }
            }
        }
    }

    revealLeave() {
        $(".join").slideUp(200);
        if (this.globalMode) {
            $("[data-tournament-id='" + this.joinedTournament + "'] .leave").delay(200).slideDown(200);
        } else {
            if (!this.revealed || this.revealed === "join") {
                this.revealed = "leave";
                $("[data-tournament-id='" + this.joinedTournament + "'] .leave").stop(true).delay(1000).slideDown(200);
            }
        }


    }

    showJoin() {
        const planned = $("#tournaments-planned .tournament-row,#tournaments-joined .tournament-row");
        if (planned.length) {
            planned.each(function () {
                const feeElement = $(this).find(".fee");
                if (feeElement.length) {
                    const fee = parseInt(feeElement.text().replace(/,/g, "").replace(/\./g, ""));
                    if (fee <= app.config.tokens) {
                        $(this).find(".join").stop(true).delay(250).slideDown(200);
                    }
                } else {
                    $(this).find(".join").stop(true).delay(250).slideDown(200);
                }
            });
        } else {
            $(".join").stop(true).delay(1000).slideDown(200);
        }
    }


    hideButtons(id) {
        if (id) {
            $("[data-tournament-id='" + id + "'] .btn").stop(true).slideUp(200);
        } else {
            this.revealed = null;
            $(".leave,.join").stop(true).slideUp(200);
        }
    }

    waitInGame(nameForUrl, gameName, pendingGameId) {
        app.launcher.openGame('/games/' + nameForUrl + '/play?tournament=' + pendingGameId + '&newTour=true', gameName);
    }

    addParticipant(user) {
        this.participants.append('<a id="us-' + user.id + '" href="/brugere/' + user.u + '" class="m-1 d-inline-block" title="' + user.u + '"><img src="/services/media/images/' + user.pi + '/profile-tiny/tour.jpg" alt="' + user.u + '" class="img-fluid friend-icon ' + (user.v ? 'vip' : '') + '"></a>')
    }

    removeParticipant(user) {
        $("#us-" + user.id).remove();
    }

    populateParticipants(users) {
        this.clearParticipants();
        for (let userId in users) {
            this.addParticipant(users[userId]);
        }
    }

    clearParticipants() {
        this.participants.find("a").remove();
    }

    addParticipantIcon(type) {
        switch (type) {
            case "occupied":
                this.participentIcons.append('<img src="/assets/tournaments/waiting_on.png">');
                break;

            case "needed":
                this.participentIcons.append('<img class="needed" src="/assets/tournaments/waiting_on.png">');
                break;

            case "empty":
                this.participentIcons.append('<img class="free" src="/assets/tournaments/waiting_off.png">');
                break;
        }
    }

    populateParticipantIcons(occupied, needed, empty) {
        this.clearParticipantIcons();
        for (let i = 0; i < occupied; i++) {
            this.addParticipantIcon("occupied");
        }
        for (let i = 0; i < needed; i++) {
            this.addParticipantIcon("needed");
        }
        for (let i = 0; i < empty; i++) {
            this.addParticipantIcon("empty");
        }
    }

    clearParticipantIcons() {
        this.participentIcons.find("img").remove();
    }
}
